import { CustomNode } from '../../../types';
import { sendActionOptions } from './sendAction.constants';

export const sendActionBaseConfig: CustomNode = {
  getCustomConfig(model) {
    return {
      ...sendActionOptions,
      ...this.getNodeConfig(model),
    };
  },

  getNodeConfig() {
    return {};
  },
};
